import React from 'react';
import { useNavigate } from 'react-router-dom';
import FilterPopover from '../ui/FilterPopover';
import IconButton from '../ui/IconButton';
import { useRole } from '../../hooks/useRole';
import { SIDE_FILTER_OPTIONS, DEFAULT_TEAM_FILTERS, type SideFilter } from '../../utils/teamView';
import type { TeamLifecycle } from '../../types/Team';
import {
  requestTeamExport, setTeamLifecycle, setTeamShowDeactivated, setTeamSide, useTeamUi,
} from './teamUiStore';

const LIFECYCLE_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' },
  { value: 'trash', label: 'Trash' },
];

/**
 * The Team controls in Header's breadcrumb bar: one Filters popover (list,
 * side, deactivated people), then icon buttons for New member and Export
 * (Refresh is in the global header). Only admins and owners can open the Team page, so New is shown
 * to whoever sees the bar.
 */
const TeamBar: React.FC = () => {
  const { isAdmin } = useRole();
  const navigate = useNavigate();
  const { filters, lifecycle, tab } = useTeamUi();
  if (!isAdmin) return null;
  return (
    <>
      {tab === 'members' && (
        <FilterPopover
          selects={[
            {
              key: 'list', label: 'List', options: LIFECYCLE_OPTIONS, value: lifecycle, defaultValue: 'active',
              onChange: v => setTeamLifecycle(v as TeamLifecycle),
            },
            {
              key: 'side', label: 'Side', options: SIDE_FILTER_OPTIONS, value: filters.side, defaultValue: DEFAULT_TEAM_FILTERS.side,
              onChange: v => setTeamSide(v as SideFilter),
            },
          ]}
          toggles={[{
            key: 'deactivated', label: 'Show deactivated people', chipLabel: 'Deactivated',
            checked: filters.showDeactivated, onChange: setTeamShowDeactivated,
          }]}
        />
      )}
      <IconButton icon="plus" label="New member" onClick={() => navigate('/team-member/new')} />
      {tab === 'members' && <IconButton icon="download" label="Export" onClick={requestTeamExport} />}
    </>
  );
};

export default TeamBar;
